import { connect } from 'react-redux';
import { ThreadsPanelItemComponent } from '../components/ThreadsPanelItemComponent';
import { threadHasError } from '../selectors';

// @ts-expect-error $TSFixMeError: Property 'thread' does not exist on type '{}'.
export default connect((state, { thread }) => ({
    hasError: threadHasError(state, { threadId: thread.id }),
}))(ThreadsPanelItemComponent);
